import { JSX } from "react"
import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { RootState } from "../store/store"

export default function GuestRoute({
  children,
  allowAdmin = false
}: {
  children: JSX.Element
  /** Lets a logged-in admin stay on this route instead of being sent to
   * /home — used on "/" so admins can view and edit the live marketing
   * page itself (site-content editing pilot). */
  allowAdmin?: boolean
}) {
  //Token aus localStorage lesen
  const token = localStorage.getItem("token")
  const isAdmin = useSelector((state: RootState) => Boolean(state.auth.user?.isAdmin))

  //Wenn Token da ist wird man zur Homepage weitergeleitet, außer ein Admin
  //darf auf dieser Route bleiben (siehe allowAdmin)
  if (token && !(allowAdmin && isAdmin)) {
    return <Navigate to="/home" />
  }

  //Wenn kein Token dann zurück
  return children
}
